var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdxCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 255.094,
    height: 119.666,
    viewBox: "0 0 255.094 119.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1659",
    x: 74.926,
    y: 0,
    width: 180.168,
    height: 99.427,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#793170",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1518",
    "data-name": "Group 1518",
    transform: "translate(-462.939 -272.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_27",
    "data-name": "Subtraction 27",
    d: "M40.128,61.4a10.46,10.46,0,0,1-2.873-.36c-2.431-.7-9.134-2.914-9.635-3.369a2.827,2.827,0,0,1,.8-2.763c.967.158,4.259.957,6.905,1.6h.006c1.5.364,2.8.679,3.413.814a8.835,8.835,0,0,0,1.836.156,18.97,18.97,0,0,0,4.666-.571c.239-.072,23.909-7.251,24.148-7.383.093-.052.241-.152.413-.267.25-.169.561-.378.809-.509.1-.03.208-.07.35-.119a23.71,23.71,0,0,1,2.332-.7.957.957,0,0,1,.232-.029,1.542,1.542,0,0,1,1.2.843c.335-.164.672-.336,1-.513.289-.151.583-.318.965-.538a49.786,49.786,0,0,0-4.912-3.739,1.462,1.462,0,0,1-.436.068,1.272,1.272,0,0,1-.384-.059l-3.65-.607c-11.693,2.213-19.658,3.634-23.671,4.225-.9.134-1.743.236-2.521.3a11.414,11.414,0,0,1-3.638.485c-2.26,0-4.163-.435-4.332-.99H33.14v-.813c-.171-.113-.332-.225-.468-.319a9.711,9.711,0,0,0-1.4-.854,2.667,2.667,0,0,1-.258-.142l-.005,0a54.544,54.544,0,0,1-7-5.954c-2.469-2.348-5.458-5.34-8.418-8.426l-.34.538c-.806,1.274-2.305,3.643-2.954,4.7a1.4,1.4,0,0,1-1.183.757,1.328,1.328,0,0,1-1.067-.563A1.058,1.058,0,0,1,9.9,35.3c.155-.409.438-1.367.738-2.381.559-1.89,1.254-4.242,1.775-5.421-1.349-1.456-2.277-2.5-2.481-2.791l-.425-.6c-4.086-5.8-6.812-9.8-8.1-11.894.143.119.306.248.488.38.509.372,1.79,1.316,3.562,2.622l.013.01,2.01,1.482.406.3c7.426,5.473,19.855,14.633,22.906,16.825A16.78,16.78,0,0,0,40.5,36.6a22.808,22.808,0,0,0,3.149-.217c1.052-.149,10.3-1.643,12.138-1.94,13.225-2.135,35.16-5.7,38.085-6.218a6.286,6.286,0,0,0,1.772-.552c-1.669,2.6-3.271,5.029-4.76,7.218a13.015,13.015,0,0,1-8.765,5.63c-.273.047-1.76.333-3.831.731l-.013,0c-1.723.332-3.348.644-4.967.953a2.85,2.85,0,0,1-.112.333,2.8,2.8,0,0,1-.139.291,46.591,46.591,0,0,1,5.139,4,32.1,32.1,0,0,1,6.079-2.571,54.238,54.238,0,0,1,10.8-2.035c3.532-.34,7.009-.513,10.334-.513a60.74,60.74,0,0,1,15.317,1.643c4.027,1.1,6.358,2.648,6.742,4.488a2.854,2.854,0,0,1,.06.511v.15c-.067,2.481-3.476,4.8-10.134,6.887a48.5,48.5,0,0,1-14.5,2.281,43.338,43.338,0,0,1-14.111-2.322,34.381,34.381,0,0,1-6.909-3.192A14.424,14.424,0,0,1,78.458,49.5c-.148-.188-.325-.393-.541-.626l-.066.038-.008,0-.112.065L77.7,49c-.442.255-.823.475-1.185.664-.4.217-.815.426-1.221.622.1.754-.057,1.318-.442,1.545-.289.131-.524.267-.751.4a7.248,7.248,0,0,1-1.712.757c-.169.022-.415.04-.675.06a7.967,7.967,0,0,0-1.21.143c-7.211,2.187-22.419,6.759-24.569,7.339A22.971,22.971,0,0,1,40.128,61.4Zm65.493-18.071c-3.284,0-6.78.176-10.389.524-8.684.836-13.2,2.8-15.844,4.2.124.142.23.27.325.39a13.012,13.012,0,0,0,3.011,2.326,33.015,33.015,0,0,0,6.631,3.063,41.583,41.583,0,0,0,13.523,2.221,46.841,46.841,0,0,0,14.01-2.209c7.015-2.2,9.226-4.37,8.956-5.668-.251-1.205-2.3-2.406-5.619-3.3A57.223,57.223,0,0,0,105.621,43.325ZM40.5,35.525a15.7,15.7,0,0,1-9.07-2.566C28.39,30.774,15.986,21.631,8.575,16.169l-.035-.026c-2.949-2.174-5.278-3.89-6-4.416C1.382,10.876.875,10.128,1.035,9.5c.215-.836,1.621-1.429,4.18-1.762,5.946-.776,48.093-6.31,49.636-6.656a4.221,4.221,0,0,1,.912-.079A18.263,18.263,0,0,1,64.6,3.63c2.477,1.723,20.042,13.347,26.654,17.723l.007,0,2.425,1.605c1.2.8,2.423,1.985,2.23,2.906-.131.624-.881,1.06-2.23,1.3-2.68.47-23.017,3.786-38.068,6.217-7.292,1.176-11.482,1.846-12.118,1.936A21.507,21.507,0,0,1,40.5,35.525Zm22.8-9.731c-2.311,0-3.943.632-4.06,1.572a1.113,1.113,0,0,0,.278.824c.718.918,2.62,1.685,4.847,1.954a13.3,13.3,0,0,0,1.594.1c2.31,0,3.942-.632,4.06-1.572a1.112,1.112,0,0,0-.277-.823c-.717-.918-2.62-1.686-4.847-1.956A13.637,13.637,0,0,0,63.3,25.794Z",
    transform: "translate(461.933 330.319)",
    fill: "#793170"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1518-2",
    "data-name": "Group 1518",
    transform: "translate(-17.733 -38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M-9367.858,8876.84l33.127-17.081-.416,1.775,1.17,33.245Z",
    transform: "translate(4234.837 -11997.908) rotate(-30)",
    fill: "#fff",
    stroke: "#793170",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1501",
    "data-name": "Group 1501",
    transform: "translate(713.266 383.512) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 232.59, 73.46)",
    filter: "url(#Rectangle_1659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1659-2",
    "data-name": "Rectangle 1659",
    transform: "translate(232.59 73.93) rotate(180)",
    fill: "#fff",
    stroke: "#793170",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.168,
    height: 54.427,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134.168,
    height: 53.427,
    rx: 4.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500",
    transform: "translate(135.168 40.394) rotate(180)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "a1b2",
    fill: "#402b49",
    fontSize: 18,
    fontFamily: "SourceSansPro-Light, Source Sans Pro",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45.814,
    y: 18
  }, "a1b2"))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdxCode);
export default __webpack_public_path__ + "static/media/idxCode.26a4b16af8bb4e15c6d56f852d07c7c9.svg";
export { ForwardRef as ReactComponent };